import { CalendarCheck, Clock, Filter, MessageCircle } from "lucide-react";
import { StatCard, StatGrid, formatNumber, getTrend } from "./ui";

const BookingKpiCards = ({ funnel, previousPeriod, avgBookingDuration }: any) => {
  const f = funnel || {};
  const prev = previousPeriod || {};
  const conversionRate = f.booking_sessions > 0 ? ((f.booking_confirmed / f.booking_sessions) * 100).toFixed(1) : "0";
  const durationVal = avgBookingDuration || 0;
  const durationDisplay = durationVal >= 1
    ? `${Math.round(durationVal)}m`
    : durationVal > 0
      ? `${Math.round(durationVal * 60)}s`
      : "0m";

  const conversion = parseFloat(conversionRate);
  return (
    <StatGrid className="booking-kpi-row lg:grid-cols-4">
      <StatCard label="Total Bookings" icon={<CalendarCheck />} tone="success"
        value={formatNumber(f.booking_confirmed || 0)} trend={getTrend(f.booking_confirmed || 0, prev.total_bookings || 0)} />
      <StatCard label="Booking Sessions" tooltip="Number of chat sessions that entered the booking flow" icon={<MessageCircle />}
        value={formatNumber(f.booking_sessions || 0)} trend={getTrend(f.booking_sessions || 0, prev.booking_sessions || 0)} />
      <StatCard label="Conversion Rate" tooltip="Percentage of booking sessions that result in a confirmed booking" icon={<Filter />} tone="info"
        value={`${conversion}%`} trend={getTrend(conversion, prev.conversion_rate || 0)} />
      <StatCard label="Avg Duration" tooltip="Average time from booking start to confirmation" icon={<Clock />} tone="warning"
        value={durationDisplay} />
    </StatGrid>
  );
};

export default BookingKpiCards;
